import React, { Component } from 'react'
import _ from 'lodash'
import { getAttribute } from '../utils/models'
import { Input } from 'antd'
import FormItem from './FormItem'

class String extends Component {

    render() {
        const { getFieldDecorator } = this.props.form
        const attribute = getAttribute(this.props.model, this.props.attribute)

        if (attribute && attribute.isEmail) {
            _.first(this.props.fieldSettings.rules).type = 'email'
    }

        return (
            <FormItem {...this.props}>
                {getFieldDecorator(this.props.attribute, this.props.fieldSettings)(
                    <Input size="large" disabled={this.props.disabled} onChange={this.props.handleChange} placeholder={this.props.placeholder} />
                )}
            </FormItem>
        )
    }

}

export default String


// WEBPACK FOOTER //
// ./src/inputs/String.js